<template>
  <div>
    <subscriber-form
      :init-form-data="initFormData()"
      :baker="baker"
      :form-type="formType"
      :is-square-loaded="true"
      :credit-card-error="creditCardError"
      @square-card-created="squareCardCreated"
      @showSubtotal="showSubtotalFn"
      v-if="(formStatus == 'ready' || formStatus == 'sending') && loadForm"
    />
    <div v-if="baker.state == 'Draft'">Coming Soon!</div>
    <div
      v-if="showSubtotal"
      class="fixed top-0 left-0 w-screen h-screen-custom"
    >
      <div
        class="absolute w-screen h-screen-custom bg-gray-900 bg-opacity-60"
        @click="showSubtotal = false"
      ></div>
      <div
        data-type="card"
        class="bg-gray-100 box-border p-4 absolute bottom-0 left-6 right-6 shadow-2xl z-20 max-w-2xl mx-auto"
      >
        <h1 class="font-bold text-xl text-gray-800 mb-2">Checkout</h1>
        <div class="absolute top-4 right-4" @click="showSubtotal = false">
          <img src="/images/close-circle-outline.svg" alt="Close this tab" />
        </div>
        <div>
          <p class="text-gray-800">
            {{ subscriber.first_name }} {{ subscriber.last_name }}
          </p>
          <p class="text-gray-800">{{ subscriber.phone_number }}</p>
          <p class="text-gray-800">{{ subscriber.email_address }}</p>
        </div>
        <table
          v-if="
            baker.subscription_form === 'full' ||
            baker.subscription_form === 'gather'
          "
          class="my-4 bg-white rounded w-full"
        >
          <tbody v-if="baker.payment_processor === 'square'" class="">
            <tr class="">
              <td class="text-gray-600 py-2 pr-4 pl-2">
                Baking Notification Project Monthly Subscription
              </td>
              <td class="text-gray-800 font-bold py-2 pr-2 text-right">
                {{ moneyFormat(subscriptionCosts.currentCharge) }}/month
              </td>
            </tr>
            <tr class="border-b border-gray-100">
              <td colspan="2" class="text-gray-600 pb-2 px-8 italic">
                - Access to baking notifications from {{ baker.name }}
              </td>
            </tr>
            <tr
              v-if="subscriptionCosts.specialNotice"
              class="border-b border-gray-100"
            >
              <td colspan="2" class="text-gray-600 p-2">
                Promotion: {{ subscriptionCosts.specialNotice }}
              </td>
            </tr>
            <tr class="">
              <td
                v-if="subscriptionCosts.specialNotice"
                class="py-2 font-bold pl-2 text-gray-600"
              >
                Recurring charge after first month
              </td>
              <td v-else class="py-2 font-bold pl-2 text-gray-600">Total</td>
              <td class="py-2 font-bold text-gray-800 pr-2 text-right">
                {{ subTotalText() }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="flex justify-center">
          <Button
            v-if="formType === 'full'"
            button-text="Subscribe"
            :click="submitPayment"
            type="primary"
            id="checkoutBtnSubscribe"
          />
          <Button
            v-if="formType === 'waitlist'"
            button-text="Join the Waitlist"
            :click="addToWaitlist"
            type="primary"
          />
        </div>
      </div>
    </div>
    <div v-if="formStatus === 'success'">
      <div class="prose-tng">
        <h1>
          Thank you for subscribing to baking notifications from
          {{ baker.name }}!
        </h1>
        <p class="mb-4">
          Check your mobile phone for a confirmation text message from the
          Baking Notification Project. Your subscription will not be active and
          your card will not be charged until you text "CONFIRM" to verify your
          number.
        </p>
        <p>
          If you do not receive a text message within 5 minutes, email us at
          <a
            class="text-blue-600 underline"
            href="mailto:support@thebakingnotificationproject.com"
            >support@thebakingnotificationproject.com</a
          >
          for support.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SubscriberForm from "~/components/SubscriberForm.vue";
import Button from "~/components/form/Button.vue";
import paymentProcessorFactory from "~/lib/PaymentProcessors/PaymentProcessorFactory";
import axios from "~/axios";

const $axios = axios();

export default {
  components: { SubscriberForm, Button },
  data: function () {
    return {
      baker: window.baker,
      showSubtotal: false,
      creditCardError: false,
      uuid: false,
      subscriber: false,
      loadForm: false,
      subscriptionCosts: {
        original: 10,
        currentCharge: 10,
        promoCodePrice: 0,
        specialNotice: null,
      },
      formStatus: "ready",
    };
  },
  computed: {
    formType() {
      if (
        this.baker &&
        (this.baker.subscription_form === "gather" ||
          this.baker.subscription_form === "full")
      ) {
        return "full";
      } else if (this.uuid !== false) {
        return "full";
      } else {
        return "waitlist";
      }
    },
  },
  methods: {
    async submitPayment() {
      const processor = paymentProcessorFactory(this.baker.payment_processor);
      try {
        let result = await processor.submit(this);
        if (result) {
          this.showSubtotal = false;
          this.formStatus = "success";

          // @TODO: Hack, use VueRouter when we refactor this whole thing.
          window.history.replaceState(
            {},
            "",
            `/${this.baker.slug}/subscribe/success`,
          );

          this.hidePagePartsPostSubmission();
        }
      } catch (e) {
        this.showSubtotal = false;
        this.creditCardError = true;
      }
      return true;
    },
    async addToWaitlist() {
      const body = JSON.stringify({
        first_name: this.subscriber.first_name,
        last_name: this.subscriber.last_name,
        email_address: this.subscriber.email_address,
        phone_number: this.subscriber.phone_number,
        waitlist: "waitlist",
        project_id: this.baker.id,
        // @TODO: Hack.
        bnpSession: window.localStorage.getItem("bnp-session"),
        newsletter_signup: this.subscriber.newsletter_signup,
      });

      return $axios
        .post("/api/waitlist", body, {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        })
        .then((data) => {
          this.showSubtotal = false;
          this.formStatus = "success";

          // @TODO: Hack, use VueRouter when we refactor this whole thing.
          window.history.replaceState(
            {},
            "",
            `/${this.baker.slug}/subscribe/success`,
          );

          this.hidePagePartsPostSubmission();
        });
    },
    hidePagePartsPostSubmission() {
      const domElements = document.querySelectorAll(".bnp-visibility");

      domElements.forEach((el) => {
        el.classList.add("hidden");
      });
    },
    initFormData() {
      if (this.subscriber === false) {
        return {
          address: {},
          billing_address: {},
          billing_address_same_as_address: true,
          accepted_terms_of_service: true,
          newsletter_signup: false,
        };
      } else {
        return this.subscriber;
      }
    },
    showSubtotalFn(e) {
      this.subscriber = e;
      this.showSubtotal = true;
    },
    subTotalText() {
      return `${this.moneyFormat(this.subscriptionCosts.currentCharge)}/month`;
    },
    moneyFormat(amount) {
      const processedAmount = amount ? amount : 10;

      const dollars = Math.floor(processedAmount);
      const cents = `${(processedAmount * 100) % 100}`.padStart(2, "0");
      return `$${dollars}.${cents}`;
    },
    squareCardCreated(e) {
      this.card = e;
    },
  },
  mounted() {
    const vue = this;

    setTimeout(() => {
      vue.subscriptionCosts.currentCharge = vue.baker.subscription_price * 1;
    }, 1);

    const params = new URLSearchParams(window.location.search);
    const uuid = params.get("uuid");

    if (uuid) {
      this.uuid = uuid;
      $axios
        .get("/api/tempurl/" + uuid)
        .then((response) => {
          if (response.data.data) {
            vue.subscriber = response.data.data;
            // @TODO: Hack.

            const domElements = document.querySelectorAll(
              ".waitlist-notification",
            );

            domElements.forEach((el) => {
              el.classList.add("hidden");
            });

            const domElement = document.querySelector(".waitlist-title");
            domElement.innerHTML = `Subscribe to baking
            notifications from ${vue.baker.name}`;

            vue.subscriber.billing_address_same_as_address = true;
            vue.subscriber.phone_number = vue.subscriber.phone_number.slice(2);
            vue.loadForm = true;
          }
        })
        .catch((error) => {
          console.log("uuid not found", error);
        });
    } else {
      this.loadForm = true;
    }
  },
  name: "BakerSubscribeApp",
};
</script>
